import styled from 'styled-components';

export const FallbackWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-lg) var(--spacing-md);
  background: var(--bg-section);
`;

export const FallbackCard = styled.div`
  width: 100%;
  max-width: 440px;
  background: var(--bg-card);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  padding: var(--spacing-xl) var(--spacing-lg);
  text-align: center;

  .brand-logo {
    display: block;
    height: 22px;
    width: auto;
    max-width: 100%;
    margin: 0 auto var(--spacing-lg);
  }

  h1 {
    font-size: var(--text-2xl);
    margin-bottom: var(--spacing-sm);
  }

  p {
    color: var(--text-secondary);
    font-size: var(--text-sm);
    margin-bottom: var(--spacing-lg);
  }
`;

export const FallbackActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-sm);
  justify-content: center;
`;
